export default "__VITE_ASSET__ee6ca3a2__"